
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import { Observer } from 'mobx-vue'
import { EnumUserFollowRef, EnumGuildMemberType } from '@xt/client/enums/kindred-spirit'
import { $service } from '@xt/client/experimental/request/service'
import { EnumApiUser } from '@xt/client/api/user'
import { EnumFollowStatus } from '@xt/client/enums/my'

@Observer
@Component({
  components: {
    HeaderImage,
    InfiniteLoading
  }
})
export default class MemberListModal extends Vue {
  visible: boolean = false

  data: {
    guildId: string
  } | null = null

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  get EnumGuildMemberType() {
    return EnumGuildMemberType
  }

  get EnumUserFollowRef() {
    return EnumUserFollowRef
  }

  get body() {
    return {
      guildId: this.data?.guildId
    }
  }

  get PageStore() {
    return this.$store.$tonghao.Manager
  }

  async handleFollow(memberId: string, status: EnumUserFollowRef) {
    const hasFollow = !(status === EnumUserFollowRef.UNFOCUS || status === EnumUserFollowRef.BEFOCUS)

    const [, res] = await $service<boolean>({
      url: EnumApiUser.FocusUser,
      method: 'POST',
      data: {
        focusStatus: !hasFollow ? EnumFollowStatus.Yes : EnumFollowStatus.No,
        followedId: memberId
      },
      params: {
        focusStatus: !hasFollow ? EnumFollowStatus.Yes : EnumFollowStatus.No,
        followedId: memberId
      }
    })

    if (res === true) {
      const oldList = [...this.toJS(this.PageStore.pagePagination.dataSource)]
      const newList = oldList.map(item => {
        if (item.memberId === memberId) {
          if (status === EnumUserFollowRef.FOCUS || status === EnumUserFollowRef.MUTUALFOCUS) {
            item.focusRef = EnumUserFollowRef.UNFOCUS
          } else if (status === EnumUserFollowRef.BEFOCUS) {
            item.focusRef = EnumUserFollowRef.MUTUALFOCUS
          } else if (status === EnumUserFollowRef.UNFOCUS) {
            item.focusRef = EnumUserFollowRef.FOCUS
          }
        }
        return item
      })
      this.PageStore.pagePagination.updateSource(newList)
    }
  }

  toMemberCenter(memberId: string) {
    if (!memberId) return

    window.open(`/my/center?memberId=${memberId}`, '_blank')
  }

  getBtnText(status: EnumUserFollowRef) {
    return status === EnumUserFollowRef.FOCUS ? '已关注' : status === EnumUserFollowRef.MUTUALFOCUS ? '互相关注' : '关注'
  }

  show(data: { guildId: string }) {
    if (!data) return

    this.data = data

    this.visible = true
  }

  hide() {
    this.visible = false
  }

  @Emit('closed')
  onClosed() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
